module.exports = __webpack_public_path__ + "assets/312eaf144d2c0724a71e3d055616664b.mp3";